import { Col, Row, Spin } from 'antd';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { getStyleVariableValue, truncateText } from '../../../../../utilz';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload?.length) {
    const { productCode, counts, productDesc } = payload[0].payload;

    return (
      <Row className="state-tooltip px-16 py-10 d-flex flex-direction-column" align="middle">
        <Col>
          <table>
            <tr>
              <td className="text-right py-2 px-5">
                <div className="text-white">Product Code: </div>
              </td>
              <td className="py-2 px-5">
                <div className="text-white">{productCode}</div>
              </td>
            </tr>
            <tr>
              <td className="text-right py-2 px-5">
                <div className="text-white">Total Products: </div>
              </td>
              <td className="py-2 px-5">
                <div className="text-white">{counts}</div>
              </td>
            </tr>
            <tr className="v-align-top">
              <td className="text-right py-2 px-5">
                <div className="text-white">Description: </div>
              </td>
              <td className="py-2 px-5">
                <div className="text-white white-space-normal">{productDesc}</div>
              </td>
            </tr>
          </table>
        </Col>
      </Row>
    );
  }

  return null;
};

const ClaimBarChartForProduct = ({ data = null }) => {
  return (
    <>
      {data?.length > 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ bottom: 20, left: 3, right: 0, top: 10 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="productCode"
              tick={{
                fill: getStyleVariableValue('--disabled-text'),
                fontSize: 10,
                fontWeight: '600',
              }}
              tickFormatter={(value) => truncateText(value, 10)}
              interval="equidistantPreserveStart"
              angle={-25}
              textAnchor="end"
              tickMargin={8}
            />
            <YAxis
              tick={{
                fill: getStyleVariableValue('--disabled-text'),
                fontSize: 12,
              }}
              width={40}
            />
            <Tooltip
              content={<CustomTooltip />}
              wrapperStyle={{
                backgroundColor: getStyleVariableValue('--dark'),
                border: 0,
                whiteSpace: 'nowrap',
                zIndex: 10,
              }}
            />
            <Bar dataKey="counts" fill={getStyleVariableValue('--info')} barSize={18} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Spin spinning={!data} />
      )}
    </>
  );
};

export default ClaimBarChartForProduct;
